import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';

@Component({
	selector: 'app-typeHandicap-modal-detail',
	templateUrl: './typeHandicap-modal-detail.component.html',
	styleUrls: ['./typeHandicap-modal-detail.component.scss']
})
export class TypeHandicapModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		])
	});

	typeHandicap: TypeHandicap;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.typeHandicap ? this.typeHandicap.name : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.typeHandicap.name = this.formEdit.get('name').value;
		this.facade.typeHandicapService.updateTypeHandicap(this.typeHandicap).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.typeHandicapService
			.deleteTypeHandicap(this.typeHandicap.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.typeHandicapService
			.deleteTypeHandicap(this.typeHandicap.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
